import styled from 'styled-components';

export const TestOrderModeToastContainer = styled.div`
  width: 150px;
  height: 60px;
  padding: 10px;
  top: 120px;
  background-color: rgb(255, 45, 56);
  border-radius: 10px;
  color: white;
  right: 20px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  position: fixed;
  z-index: 1000;
  font-weight: bold;

  @media (max-width: 1250px) {
    top: 120px;
  }

  @media (max-width: 1200px) {
    top: 126px;
  }
  @media (max-width: 767px) {
    top: 100px;
  }

  @media (max-width: 599px) {
    top: 131px;
  }
`;

export const TestOrderModeToastClearButton = styled.div`
  cursor: pointer;
  text-decoration: underline;
`;
